module.exports = __webpack_public_path__ + "VectipedeBk-Regular-ae514a6f238c3e190c684fd2c02f1916.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/fonts/VectipedeBk-Regular.svg
// module id = 172
// module chunks = 1